import { FormItemList } from 'components/core-ui/FormItemList'
import { toDocumentsFormItemsList } from './serializers'
import { AddImageIcon, UploadFileIcon } from 'icons'
import { Box, Grid } from '@mui/material'
import { AsyncAutocomplete } from 'components/core-ui/AsyncAutocomplete'
import { IconButton } from '@fullscreendigital/carrefour-dex-fe'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { Button } from '@fullscreendigital/carrefour-dex-fe'
import ls from './DocumentsListForm.modules.scss'
import { UploadDocument } from '../UploadFilesModal'

export interface DocumentsListFormProps {
  documents: UploadDocument[]
  setDocuments: (documents: UploadDocument[]) => void
  selectedDocumentType: AutocompleteOption
  setSelectedDocumentType: (option: AutocompleteOption) => void
  setStep: (step: number) => void
  cancelModal: (event: React.MouseEvent<HTMLElement>) => void
  saveData: () => void
  documentTypesOptions: AutocompleteOption[]
}

const DocumentsListForm = (props: DocumentsListFormProps) => {
  const {
    documents,
    setDocuments,
    selectedDocumentType,
    setSelectedDocumentType,
    setStep,
    cancelModal,
    saveData,
    documentTypesOptions
  } = props

  const removeDocument = (id: number) => {
    const newDocuments = documents.filter(doc => doc.id !== id)
    setDocuments(newDocuments)
  }

  return (
    <>
      <Box className={ls.documentsListContainer}>
        {!!documents.length && (
          <FormItemList
            items={toDocumentsFormItemsList(documents)}
            startIcon={<UploadFileIcon />}
            deleteHandler={removeDocument}
            containerClassName={ls.formItemListContainer}
          />
        )}
        <Box>
          <Grid container spacing={2}>
            <Grid xs={12} md={7} item>
              <AsyncAutocomplete
                variant="outlined"
                name="documentType"
                label="Alege tipul documentului"
                value={selectedDocumentType}
                options={documentTypesOptions || []}
                getOptionDisabled={option =>
                  !option.multiselect &&
                  documents.some(doc => doc.documentType.value === option.value)
                }
                onChange={value => setSelectedDocumentType(value)}
              />
            </Grid>
            <Grid xs={12} md={5} item>
              <IconButton
                startIcon={<AddImageIcon />}
                variant="outlined"
                size="large"
                label="Adauga imagini"
                disabled={!selectedDocumentType}
                onClick={() => setStep(1)}
                style={{ width: '100%', marginTop: '16px' }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Grid container spacing={4}>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={cancelModal} />
          {!!documents.length && (
            <Button variant="contained" type="submit" label="Salveaza" onClick={() => saveData()} />
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default DocumentsListForm
